'use client';
import { useField } from 'formik';

import { classNames } from '@repo/ui/src/utils/classNames';
import { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name: string;
  className?: string;
  inputStyles?: string;
  hideLabel?: boolean;
  labelStyles?: string;
  darkBackground?: boolean;
  inputAddon?: React.ReactNode;
}

const Input = ({
  label,
  className,
  inputStyles,
  hideLabel,
  labelStyles,
  required = false,
  darkBackground = false,
  inputAddon,
  ...props
}: InputProps) => {
  const [field, meta] = useField(props);
  const showError = meta.touched && meta.error;

  return (
    <div className={classNames('w-full', className)}>
      <label className={classNames('w-full flex flex-col tra-text-web-body-m', labelStyles)}>
        {!hideLabel && (
          <span className="mb-2 dark:text-warm-100">
            {label}
            {required && ' *'}
          </span>
        )}
        <div className="relative">
          <input
            aria-describedby={showError ? `${props.name}-error` : undefined}
            className={classNames(
              'tra-input-text',
              'tra-text-web-body-m',
              'w-full',
              meta.touched && meta.error && 'border-red-400',
              inputStyles,
            )}
            aria-required={required ?? 'true'}
            {...field}
            {...props}
          />
          {inputAddon}
        </div>
      </label>
      {showError ? (
        <span
          className={classNames('tra-input-error', darkBackground && 'text-alert-200')}
          id={`${props.name}-error`}
          data-testid="input-error"
        >
          {meta.error}
        </span>
      ) : null}
    </div>
  );
};

export default Input;
